import { DateTime } from 'luxon';

import { VeeamJobApi } from '@apps/bckp/api/models/veeamJob-api';
import { DatesService } from '@common/services';

export class VeeamJob
{
    public vmDisplayName: string;
    public documentId: string;
    public jobType: string;
    public taskState: string;
    public taskCreationTime: string;
    public name: string;
    public sessionState: string;
    public nextRun: string;
    public sessionCreationTime: string;
    public taskEndTime: string;
    public totalSize: number;
    public backupServerReference: string;
    public dtTaskCreationTime: DateTime;
    public dtSessionCreationTime: DateTime;
    public dtTaskEndTime: DateTime;
    public assetType: string;

    public static mapperFromApi (source: VeeamJobApi): VeeamJob
    {
        const target = Object.assign(new VeeamJob(), source);

        target.dtTaskCreationTime = DatesService.UtcStringToDateTimeHourStatic(source.taskCreationTime);
        target.dtSessionCreationTime = DatesService.UtcStringToDateTimeHourStatic(source.sessionCreationTime);
        target.dtTaskEndTime = DatesService.UtcStringToDateTimeHourStatic(source.taskEndTime);

        target.totalSize = source.totalSize / Math.pow(2, 30);

        return target;
    }
}